import * as React from 'react';
import {
	Box,
	LinearProgress,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	IconButton,
	Tooltip, // ⬅️ agregado
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import {
	CurrencyRateConfigurationLockMode,
	getCurrencyRateConfigurationLockModeName,
	ICurrencyRateConfigurationList,
} from '../../../types';
import { formatDateTimeToShowUserFromSaleOrderApiValue, formatDateToShowUser } from '../../../../common/helpers';

export type CurrencyRateConfigurationsTableProps = {
	rows: ICurrencyRateConfigurationList[];
	loading: boolean;
	onEdit: (row: ICurrencyRateConfigurationList) => void;
	onViewLogs: (row: ICurrencyRateConfigurationList) => void;
};

export const CurrencyRateConfigurationsTable = ({
	rows,
	loading,
	onEdit,
	onViewLogs,
}: CurrencyRateConfigurationsTableProps): JSX.Element => {
	const isEmpty = !loading && rows.length === 0;

	return (
		<Paper elevation={1}>
			<Box p={2} pb={0} display="flex" alignItems="center" justifyContent="space-between">
				<Typography variant="h6">Configuraciones de tasas de cambio</Typography>
			</Box>
			{loading && <LinearProgress />}
			<TableContainer>
				<Table size="small" aria-label="currency-configs-table">
					<TableHead>
						<TableRow>
							<TableCell>Moneda</TableCell>
							<TableCell align="right">Spread</TableCell>
							<TableCell>Modo de bloqueo</TableCell>
							<TableCell>Bloqueado hasta</TableCell>
							<TableCell>Última modificación</TableCell>
							<TableCell>Modificado por</TableCell>
							<TableCell align="right">Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((r) => (
							<TableRow key={`${r.coinId}-${r.coinCode}`} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell>
									<Typography component="span" fontWeight={600}>
										{r.coinCode}
									</Typography>
								</TableCell>
								<TableCell align="right">{r.spread}</TableCell>
								<TableCell>{getCurrencyRateConfigurationLockModeName(r.lockMode)}</TableCell>
								<TableCell>
									{r.lockMode === CurrencyRateConfigurationLockMode.Until && r.lockUntil
										? formatDateToShowUser(r.lockUntil)
										: '—'}
								</TableCell>
								<TableCell>
									{r.updatedAt ? `${formatDateTimeToShowUserFromSaleOrderApiValue(r.updatedAt)}` : '—'}
								</TableCell>
								<TableCell>{r.updatedByName || '—'}</TableCell>
								<TableCell align="right">
									<Tooltip title="Modificar">
										<IconButton size="small" aria-label="Modificar configuración" onClick={() => onEdit(r)}>
											<EditIcon fontSize="small" />
										</IconButton>
									</Tooltip>
									<Tooltip title="Ver logs">
										<IconButton size="small" aria-label="Ver logs de cambios" onClick={() => onViewLogs(r)}>
											<HistoryIcon fontSize="small" />
										</IconButton>
									</Tooltip>
								</TableCell>
							</TableRow>
						))}
						{isEmpty && (
							<TableRow>
								<TableCell colSpan={7}>
									<Box p={2} textAlign="center" color="text.secondary">
										No hay configuraciones para mostrar.
									</Box>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};
